<template>
  <div class="copyright-page">
    <div class="container">
      <h1 class="page-title">版权声明</h1>
      <div class="content-container">
        <div class="content-html">
          <h2>一、版权归属</h2>
          <p>北京格瑞创新科技有限公司（以下简称"本公司"）拥有格瑞创新动漫平台（以下简称"本平台"）及其包含的所有内容的版权和其他相关知识产权，除非另有明确声明。</p>

          <h2>二、平台内容版权</h2>
          <p>1. 本平台所有漫画作品、文字、图片、音频、视频、软件、界面设计、数据汇编等内容的知识产权归本公司或相应的版权权利人所有，受《中华人民共和国著作权法》及相关国际公约的保护。</p>
          <p>2. 未经本公司或相关权利人的书面许可，任何个人或组织不得以任何方式复制、转载、传播、修改、改编、翻译、汇编、发行、展示、表演或以其他方式使用本平台的内容。</p>

          <h2>三、用户投稿版权</h2>
          <p>1. 用户在本平台投稿的原创作品，其著作权归原作者所有。用户一经投稿，即视为授予本平台在平台范围内对该作品进行展示、推广和传播的许可。</p>
          <p>2. 用户应保证其投稿的作品不侵犯任何第三方的知识产权、肖像权、名誉权等合法权益。如因用户投稿内容引发纠纷，由用户自行承担全部法律责任。</p>

          <h2>四、引用与转载</h2>
          <p>1. 在非商业用途且注明出处的前提下，用户可以合理引用本平台的内容，但引用范围应符合《著作权法》关于合理使用的规定。</p>
          <p>2. 任何媒体、网站或商业机构如需转载本平台的内容，须事先获得本公司的书面授权，并在转载页面显著位置标注来源及原文链接。</p>

          <h2>五、商标权</h2>
          <p>本平台所使用的"格瑞创新"、"格瑞创新动漫"等标识、LOGO、服务名称均为本公司所有的商标或商业标识，未经本公司书面许可，任何个人或组织不得擅自使用。</p>

          <h2>六、侵权处理</h2>
          <p>1. 本公司尊重他人的知识产权，也要求用户尊重知识产权。如果您认为本平台上的内容侵犯了您的合法权益，请及时与我们联系，并提供相关权属证明。</p>
          <p>2. 对于确属侵权的作品，本公司将在核实后及时予以删除或屏蔽处理。</p>

          <h2>七、法律适用</h2>
          <p>本版权声明的解释、效力及争议解决均适用中华人民共和国法律。如本声明的任何条款与法律相抵触，以法律规定为准。</p>

          <p class="copyright-contact">如有版权相关问题，请联系我们：</p>
          <p class="copyright-contact">邮箱：copyright@gerui-chuangxin.com</p>
          <p class="copyright-contact">电话：13810795803</p>
          <p class="copyright-update">最后更新日期：2026年1月1日</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CopyrightPage'
}
</script>

<style scoped>
.copyright-page {
  padding: 30px 0;
  min-height: calc(100vh - 120px);
  background: var(--bg);
}

.container {
  max-width: 800px;
  margin: 0 auto;
  padding: 0 20px;
}

.page-title {
  text-align: center;
  margin-bottom: 30px;
  color: var(--text);
  font-size: 28px;
}

.content-container {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 30px;
}

.content-html {
  line-height: 1.8;
  color: var(--text);
}

.content-html h2 {
  margin: 20px 0 10px;
  font-size: 22px;
  color: var(--text);
}

.content-html p {
  margin: 10px 0;
}

.content-html a {
  color: var(--brand);
  text-decoration: none;
}

.content-html a:hover {
  text-decoration: underline;
}

.copyright-contact {
  color: var(--text-dim);
  margin: 10px 0;
}

.copyright-update {
  color: var(--text-faint);
  font-size: 14px;
  margin-top: 20px;
}
</style>
